import CTA from "../CTA/CTA";
import Cards from "../Cards/Cards";
import s from "./Main.module.scss";


const Main = () => {

    return (
        <main>
            <section className={s.hero}>
                <div>
                    <h1>Atelier de la Villette</h1>
                    <p className={s.soustitre}>-&nbsp;Entreprise Adaptée&nbsp;-</p>
                    <p className={s.description}>L’atelier qui conjugue performance et inclusion,<br/> au service de vos besoins administratifs.</p>
                    <CTA
                        text="En savoir plus"
                        href="#presentation"
                        variant="nobackground"
                    />
                </div>
            </section>
            <section id="presentation" className={s.presentation}>
                <div className={s.whoWeAre}>
                    <picture>
                        <source media="(max-width: 899px)" srcset="/atelier-de-la-villette/assets/presMobile2.jpg" />
                        <source media="(min-width: 900px)" srcset="/atelier-de-la-villette/assets/pres2.jpg" />
                        <img src="/atelier-de-la-villette/assets/pres2.jpg" alt="" className={s.imagePres} />
                    </picture>
                    <div className={s.text}>
                        <h2>Qui sommes-nous&nbsp;?</h2>
                        <div>
                            <p>L’Atelier de la Villette, créé par l’association Valentin Haüy, est une entreprise adaptée agréée par la DRIEETS* qui accompagne les organisations dans plusieurs offres de services, notamment dans la gestion de leurs tâches administratives : saisie, reprographie, transcription, mise en page…</p>
                            <p>Nous nous appuyons sur une équipe professionnelle, composée majoritairement de personnes déficientes visuelles, pour offrir un service fiable, rigoureux et humain.</p>
                            <p>Notre mission est simple : répondre efficacement à vos besoins tout en contribuant à une démarche d’inclusion active.</p>
                        </div>
                        <CTA
                            text="Découvrir nos solutions"
                            href="#solutions"
                            variant="icon"
                            icon={<img src="/atelier-de-la-villette/assets/icon/sol.png" alt="" />}
                        />
                    </div>
                </div>
                <div className={s.numbers}>
                    <div className={s.number}>
                        <div>
                            <img src="/atelier-de-la-villette/assets/icon/age.png" alt="" />
                            <h3>35 ans </h3>
                        </div>                     
                        <p>Depuis 1989, l’Atelier de la Villette, Entreprise Adaptée agréée par la DRIEETS*, est partenaire des grands comptes, entreprises privées ou publiques et collectivités locales.</p>
                        <p className={s.note}>* Direction régionale interdépartementale de l'économie, de l'emploi, du travail et des solidarités</p>
                    </div>
                    <div className={s.number}>
                        <div>
                            <img src="/atelier-de-la-villette/assets/icon/salaries.png" alt="" />
                            <h3>48 salariés </h3>
                        </div>                     
                        <p>Dont 38&nbsp;salariés de production en situation de handicap (RQTH**) soit environ 80% de l’effectif dont 18 déficients visuels, aveugles et malvoyants.</p>
                        <p className={s.note}>** Reconnaissance de la qualité de travailleur handicapé</p>
                    </div>
                    <div className={s.number}>
                        <div>
                            <img src="/atelier-de-la-villette/assets/icon/secteur.png" alt="" />
                            <h3>4 secteurs </h3>
                        </div>                     
                        <p>- Réparation et restauration de cycles 
                            <br />- Impression, conditionnement et routage
                            <br />- Bureautique et secrétariat
                            <br />- Massage, bien-être en entreprise
                        </p>
                    </div>
                </div>
            </section>
            <section id="solutions" className={s.solutions}>
                <h2>Nos solutions sur-mesure</h2>
                <p>De la saisie de données à la reprographie, en passant par la transcription ou la mise en page, chaque prestation est assurée avec soin par une équipe expérimentée et engagée.</p>
                <div className={s.cards}>
                    <Cards
                        title="Réparation et restauration de cycles"
                        text="L’Atelier de la Villette prend soin de vos vélos, qu’ils soient classiques, électriques ou anciens. Nous assurons la réparation, l’entretien et la restauration avec précision, et proposons même l’électrification pour moderniser vos cycles. Notre équipe de salariés diplômés met son savoir-faire au service de votre mobilité douce, avec des prestations rapides et de qualité."
                        img="/atelier-de-la-villette/assets/cards/cycle.jpg"
                        href="https://www.avh.asso.fr/implantations/latelier-de-la-villette/devis"
                    />
                    <Cards
                        title="Imprimerie, conditionnement et routage"
                        text="Avec l’Atelier de la Villette, vos projets d'impression, de conditionnement et de routage prennent forme avec qualité et efficacité. De l’impression de supports variés au façonnage et à la mise sous pli, nous gérons chaque étape avec soin, y compris l’accessibilité en braille ou gros caractères. Un service complet, rapide et sur mesure pour valoriser vos communications."
                        img="/atelier-de-la-villette/assets/cards/imprimerie.jpg"
                        href="https://www.avh.asso.fr/implantations/latelier-de-la-villette/devis"
                    />
                    <Cards
                        title="Bureautique et secrétariat"
                        text="Boostez votre organisation avec le service de bureautique et secrétariat de l’Atelier de la Villette&nbsp;! De la transcription de réunions à la gestion de données, en passant par le traitement du courrier, le mailing ou encore la numérisation et l’archivage, notre équipe vous accompagne avec efficacité et précision. Confiez-nous vos tâches administratives et gagnez du temps pour vous concentrer sur l’essentiel."
                        img="/atelier-de-la-villette/assets/cards/bureau.jpg"
                        href="https://www.avh.asso.fr/implantations/latelier-de-la-villette/devis"
                    />
                    <Cards
                        title="Massages bien‑être en entreprise"
                        text="Profitez de séances de massage (japonais Amma, crânien, mains, visage…) directement sur votre site, réalisées par des praticiens diplômés. Une pause bien-être conçue pour diminuer le stress, stimuler la concentration et améliorer le climat de travail."
                        img="/atelier-de-la-villette/assets/cards/Massage.jpg"
                        href="https://www.avh.asso.fr/implantations/latelier-de-la-villette/devis"
                    />

                </div>  
            </section>
            <section id="collaborate" className={s.collaborate}>
                <div className={s.work}>
                    <h2>Pourquoi travailler avec l'Atelier de la Villette&nbsp;?</h2>
                    <div className={s.reasons}>
                        <div className={s.reason}>
                            <img src="/atelier-de-la-villette/assets/icon/social.png" alt="" />
                            <h3>Un impact social</h3>
                            <p>Contribuez à l’insertion de <br/>salariés en situation de handicap. </p>
                        </div>
                        <div className={s.reason}>
                            <img src="/atelier-de-la-villette/assets/icon/deduction.png" alt="" />
                            <h3>Une déduction</h3>
                            <p>Pour la contribution annuelle due par les entreprises au titre de l'obligation d'emploi des travailleurs handicapés (déclaration OETH). </p>
                        </div>
                        <div className={s.reason}>
                            <img src="/atelier-de-la-villette/assets/icon/temps.png" alt="" />
                            <h3>Un gain de temps</h3>
                            <p>Obtenez un gain de temps immédiat sur les tâches administratives.</p>
                        </div>
                        <div className={s.reason}>
                            <img src="/atelier-de-la-villette/assets/icon/local.png" alt="" />
                            <h3>Un partenariat local</h3>
                            <p>Sur Paris et la petite couronne.</p>
                        </div>
                    </div>
                </div>

                {/*}
                <span className={s.divider}></span>
                <div className={s.confidence}>
                    <h2>Ils nous font confiance</h2>
                    <div className={s.temoignage}> 
                        <p>Sorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>
                        <p><span>- Lorem Ipsum -</span></p>
                    </div>
                </div>
                */}
            </section>
            <section id="contact" className={s.contact}>
                <img class={s.contactIcon} src="/atelier-de-la-villette/assets/icon/contact.png" alt=""/>
                <h2>Envie de collaborer&nbsp;? <br/> 
                    Le plus simple, c'est de se parler&nbsp;!</h2>
                <div>
                    <CTA
                        text="Contactez-nous"
                        href="https://www.avh.asso.fr/implantations/latelier-de-la-villette/contact"
                        variant="nobackwicon"
                        icon={<img src="/atelier-de-la-villette/assets/icon/mail.png" alt="" />}
                    />
                    <CTA
                        text="Je demande un devis"
                        href="https://www.avh.asso.fr/implantations/latelier-de-la-villette/devis"
                        variant="icon"
                        icon={<img src="/atelier-de-la-villette/assets/icon/devis.png" alt="" />}
                    />
                </div>
            </section>
        </main>
    )
}

export default Main;